<template>
    <el-form :inline="true" class="pl10" :model="form">
        <el-form-item class="width45">
            <el-select v-model="depKind" placeholder="门诊类别" size="mini" @change="bookTypeChange">
                <el-option
                        v-for="item in depKinds"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item class="width45" v-if="depKind==='1'">
            <el-select :value="currentBindDoc.id" @change="bookDocChange"
                       placeholder="选择挂号医生" size="mini">
                <el-option
                        v-for="item in currentBindDocLists"
                        :key="item.id"
                        :label="item.bookDocName+'-'+item.bookDeptName"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item class="width45" v-if="depKind==='2'">
            <el-select :value="currentBindDep.bookDeptId" @change="bookDocChange"
                       placeholder="选择挂号科室" size="mini">
                <el-option
                        v-for="item in currentBindDepLists"
                        :key="item.id"
                        :label="item.bookDeptName"
                        :value="item.bookDeptId">
                </el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script>
  import {depKind} from "../../lib/hos/until";
  import {mapMutations, mapState} from 'vuex'
  import {disTypeCache, disDocCache, disDepCache} from '../../lib/cache/DisOrder'
  import {isEmpty} from '../../lib/utils'

  export default {
    name: "dis-filter",
    data() {
      return {
        depKinds: depKind,
        depKind: '1',
        dept: [],
        form: {}
      }
    },
    computed: {
      ...mapState(['currentBindDocLists', 'currentBindDepLists', 'currentBindDoc', 'currentBindDep']),
    },
    watch: {
      form: {
        handler(newV) {
          this.$emit('change', newV);
        },
        deep: true
      },
    },
    methods: {
      ...mapMutations(['setCurrentBindDoc', 'setCurrentBindDep', 'setCurrentType']),
      bookDocChange(id) {
        if (this.depKind == '1') {
          const doc = this.currentBindDocLists.find(r => r.id === id);
          disDocCache.set(doc)
          this.currentBindDocCache = doc;
          this.setCurrentBindDoc(doc);
          this.form = {
            'bookHosId': doc.bookHosId,
            'bookDepId': doc.bookDeptId,
            'bookDocId': doc.bookDocId,
            'depKind': "1"
          }
        } else {
          const dep = this.currentBindDepLists.find(r => r.bookDeptId === id);
          disDepCache.set(dep)
          this.currentBindDepCache = dep;
          this.setCurrentBindDep(dep);
          this.form = {
            'bookHosId': dep.bookHosId,
            'bookDepId': dep.bookDeptId,
            'depKind': "2"
          }
        }
      },
      bookTypeChange(val) {
        this.depKind = val;
        disTypeCache.set(val);
        if (val == "1") {
          this.bookDocChange(this.currentBindDoc.id);
        } else {
          this.bookDocChange(this.currentBindDep.bookDeptId);
        }
        this.setCurrentType(this.depKind);
      }
    },
    created() {
      if (isEmpty(disTypeCache.get())) {
        disTypeCache.set('1');
      } else {
        this.depKind = disTypeCache.get();
      }
    },
  }
</script>

<style scoped lang="scss">
    .width45 {
        width: 45%;
    }
</style>
